
import { get, upload } from 'shared/services/ApiService';

import { MOMENT_UPLOAD_URL, PROCESS_THUMBNAIL_URL } from 'shared/utils/Constants';

export const uploadFile = async (url, file) => {
    return await upload(url, file);
}

export const getMomentAssetSignedUrl = async (momentId, type, asJson, editSource, printSize) => {
    return await get(MOMENT_UPLOAD_URL(momentId, type, asJson, editSource, printSize));
}

export const processThumbnails = async (momentId, editSource, printSize) => {
    return await get(PROCESS_THUMBNAIL_URL(momentId, editSource, printSize));
}
